import React, {Component} from 'react';

import Autorization from "./Auth/Autorization";
import LoadingOverlay from "./Common/LoadingOverlay";
import App from "./App";
import AppContainer from '../containers/AppContainer';
import Loader from './Loader';
import "../assets/css/material-design-iconic-font.min.css";

/**
 *
 * @param authorized
 */
class Shunter extends Component {
    renderContent = () => {
        const {
            auth: {authorized},
            sidebar
        } = this.props;

        if (authorized) {
            return (
                <AppContainer {...sidebar} user={this.props.auth.user} />

            );
        }

        return (
            <Autorization pathname={this.props.location.pathname}/>
        );
    };

    render() {

        if (!this.props._persist.rehydrated) {
            return null;
        }
        
        return (
            <div>
                <Loader appLoading={this.props.app.appLoading} />
                {this.renderContent()}

            </div>
        );
    }
}

Shunter.propTypes = {};

export default Shunter;



// WEBPACK FOOTER //
// ./src/components/Shunter.js